<pageheader [entity]="headerAdminportal"></pageheader>
<div *ngIf="listView" class="top-btns">
    <div class="table-outer">
        <grid [entities]="adduser" [checkboxCol]="true" [entityColumns]="adduserColumns" 
        [showActions]="false" [serverPagination]="true" [pageSizes]="pageSizes"
        >
     </grid>
    </div>
 </div>
        <div *ngIf="!listView">
            <div class="report top-btns">
                <div class="form-caption-nav">
                      {{ formCaption }}
                </div>
            </div>
        </div>
            <ng-template #approveaction let-dataItem let-rowIndex="rowIndex">
                <button class="button-36 btn" (click)="approve(dataItem)" > <i class="bi bi-check2-circle" ></i> Approve</button>
            </ng-template>
            
            <ng-template #reject let-dataItem let-rowIndex="rowIndex">
                <button class="button-34 btn"(click)="rejectaction(dataItem)"><i class="bi bi-x-circle Reject" ></i> Reject</button>
              </ng-template>
              <ng-template #Remarks let-dataItem let-rowIndex="rowIndex">
                <textbox [multiline]="true" [maxlength]="500" [(ngModel)]="dataItem.Remarks" [rows]="2"
                    ngDefaultControl></textbox>
            </ng-template>   
               
              
        
      